import { defineField, defineType } from "sanity";

export const programContentType = defineType({
  type: "document",
  name: "programContent",
  title: "Program Content",
  groups: [
    { name: "meta", title: "Meta" },
    { name: "modules", title: "Modules" }
  ],
  fields: [
    defineField({
      name: "language",
      type: "string",
      hidden: true,
      validation: (Rule) => Rule.required(),
      group: "meta"
    }),
    defineField({
      name: "title",
      type: "string",
      title: "Title",
      validation: (Rule) => Rule.required(),
      group: "meta"
    }),
    // image
    defineField({
      name: "image",
      type: "image",
      title: "Image",
      group: "meta"
    }),
    defineField({
      name: "slug",
      type: "slug",
      title: "Slug",
      validation: (Rule) => Rule.required(),
      options: {
        source: "title",
        maxLength: 96
      },
      group: "meta"
    }),
    defineField({
      name: "description",
      type: "string",
      title: "Description",
      group: "meta"
    }),
    // detail text
    defineField({
      name: "detailText",
      type: "text",
      title: "Detail Text",
      group: "meta"
    }),
    // list of file attachments
    defineField({
      name: "attachments",
      type: "array",
      title: "Attachments",
      of: [{ type: "programFileAttachment", title: "File Attachment" }],
      group: "meta"
    }),
    // list of module items
    defineField({
      name: "moduleItems",
      type: "array",
      title: "Module Items",
      of: [{ type: "programModuleItem", title: "Module Item" }],
      group: "modules"
    })
  ]
});
